var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7qytq2jrda",
    d: "M0 0h20v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 .037)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6r18krso1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7qytq2jrda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.611 3.83c.86-1.013 1.437-2.427 1.277-3.83-1.234.047-2.73.804-3.616 1.817-.794.898-1.492 2.335-1.303 3.714 1.378.102 2.784-.684 3.642-1.701m3.093 8.92c-.028-3.036 2.538-4.495 2.654-4.566-1.457-2.095-3.706-2.328-4.499-2.385-2.022-.146-3.738 1.104-4.695 1.104-.97 0-2.469-1.073-4.056-1.046-2.085.032-4.006 1.187-5.08 3.012-2.166 3.672-.554 9.113 1.555 12.093 1.033 1.458 2.262 3.098 3.878 3.036 1.557-.058 2.145-.983 4.025-.983 1.878 0 2.41.983 4.054.955 1.674-.028 2.736-1.484 3.759-2.952 1.186-1.688 1.674-3.324 1.701-3.414-.036-.013-3.262-1.223-3.296-4.854",
    fill: "#959595",
    mask: "url(#6r18krso1b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5058ac0a38a1b58830ba266ff1d6663e.svg";
export { ForwardRef as ReactComponent };